export class TeamModel{
    public name = '';
    public get shortName(): string {
        const nameParts = this.name.split(' ');
        return nameParts[0];
    };
    public abbr = '';
}